import { render } from "./CaseShow.vue?vue&type=template&id=747ecb8c&scoped=true"
import script from "./CaseShow.vue?vue&type=script&lang=js"
export * from "./CaseShow.vue?vue&type=script&lang=js"

import "./CaseShow.vue?vue&type=style&index=0&id=747ecb8c&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-747ecb8c"]])

export default __exports__